export const formSubmittingClassName = 'form-submitting';

export const formSubmittingOneIfSubmittingVar =
  '--form-submitting-one-if-submitting';

export const formSubmittingDisplayBlockIfSubmittingVar =
  '--form-submitting-display-block-if-submitting';
